<template>
  <div
      class="panorama-spot__build build-panorama-spot"
      v-on="{
        [this.$panorama.utils.isMobile ? 'touchstart' : 'click']: changeCorps
      }"
  >
    <div class="build-panorama-spot__container">
      <div class="build-panorama-spot__label">
        Корпус {{ corps }}
      </div>
      <!-- <div class="build-panorama-spot__logo">
        <panorama-spot-icon icon="logo" />
      </div> -->
    </div>
  </div>
</template>

<script>
// import PanoramaSpotIcon from '@/components/elements/PanoramaSpotIcon'
export default {
  name: 'PanoramaBuildSpot',
  components: {
    // PanoramaSpotIcon
  },
  props: {
    corps: {
      type: String,
      default: '0'
    }
  },
  computed: {
    activeGroup: {
      get () {
        return this.$store.state.Panorama.Control.activeGroup
      },
      set (payload) {
        this.$store.commit('Panorama/Control/SET_ACTIVE_GROUP', payload)
      }
    },
    activeCorpus: {
      get () {
        return this.$store.state.Panorama.Control.activeCorpus
      },
      set (payload) {
        this.$store.commit('Panorama/Control/SET_ACTIVE_CORPUS', payload)
      }
    }
  },
  methods: {
    changeCorps () {
      this.activeGroup = 1
      this.activeCorpus = +this.corps
    }
  }
}
</script>

<style lang="scss" scoped>
.build-panorama-spot {
  &__container {
    position: relative;
    background: var(--panorama-background-color);
    width: 60px;
    height: 30px;
    padding: 9px;
    border-radius: 4px;
    box-sizing: border-box;
    &:hover, &:focus {
      cursor: pointer;
      filter: invert(1);
      transition: all 300ms;
    }
    @media screen and (min-width: 1024px) {
      width: 100px;
      height: 50px;
      padding: 14px;
      border-radius: 8px;
    }
    @media screen and (min-width: 1920px) {
      width: 5.21vw;
      height: 2.5vw;
      padding: 0.73vw;
      border-radius: 0.42vw;
    }
  }
  &__label {
    font-family: var(--panorama-first-font);
    font-weight: bold;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    color: var(--panorama-text-color);
    @media screen and (min-width: 1024px) {
      margin-bottom: 2px;
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 1.25vw;
      margin-bottom: 0.105vw;
    }
  }
  &__logo {
    padding: 0 1px;
    & > svg {
      width: 100%;
    }

    @media screen and (min-width: 1024px) {
      padding: 0 4px;
    }

    @media screen and (min-width: 1920px) {
      & > svg {
        width: 3.335vw;
        height: 0.7vw;
      }
    }
  }
}
</style>
